<template>
  <a-card :bordered="false">
    <search-page-view
      :col="4"
      ref="pageList"
      :itemNames="['s1','s2','s3']"
      :columns="getOrderColumns()"
      :queryParams="queryParams"
      row-key="memberId"
      :leftSpace="10"
      :requestPromise="getOrderList"
    >
      <a-form-item slot="s1" label="订单号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="渠道名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.deviceChannelName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s3" label="联系人手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.deviceChannelMobile" placeholder="请输入"></a-input>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a @click="toEditEvent(rowItem.record)">编辑</a>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import smartMixins from './smartMixins'

export default {
  name: 'OrderManager',
  mixins: [smartMixins],
  data() {
    return {
      queryParams: {}
    }
  },

  created() {
    this.queryParams = {
      merchantId: this.$store.getters.userInfo.merchantId
    }
  },
  mounted() {
  },
  methods: {
    toEditEvent(record) {
    },
    getOrderList(params) {
      return this.getHttpServices().getOrderService().post('order/iot/searchOrderList', params)
    },
    getOrderColumns() {
      return [
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '支付流水号',
          dataIndex: 'payNo'
        },
        {
          title: '订单标题',
          dataIndex: 'orderName'
        },
        {
          title: '订单金额',
          dataIndex: 'orderPrice'
        },
        {
          title: '分销佣金',
          dataIndex: 'orderCommission'
        },
        {
          title: '渠道名称(店铺名)',
          dataIndex: 'deviceChannelName'
        },
        {
          title: '联系人姓名',
          dataIndex: 'deviceChannelUserName'
        },
        {
          title: '联系人手机号',
          dataIndex: 'deviceChannelMobile'
        },
        {
          title: '支付时间',
          dataIndex: 'payTime'
        }
      ]
    }
  }

}
</script>
<style scoped>
</style>